import { render, staticRenderFns } from "./NearbyPlaces.vue?vue&type=template&id=6392b238&scoped=true"
import script from "./NearbyPlaces.vue?vue&type=script&lang=js"
export * from "./NearbyPlaces.vue?vue&type=script&lang=js"
import style0 from "./NearbyPlaces.vue?vue&type=style&index=0&id=6392b238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6392b238",
  null
  
)

export default component.exports